import React, { FC } from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import { INavButton } from '../../types';
import './styles.scss';

export interface ISubMenu {
  subMenuButtons: INavButton[];
}

const SubMenu: FC<ISubMenu> = ({ subMenuButtons }) => {
  return (
    <div className='hbh-submenu-container'>
      {subMenuButtons.map((button) => {
        return (
          <Button
            size='large'
            key={button.label}
            icon={button.icon}
            onClick={button.onClick}
            className={cn('hbh-menu-button', button?.className)}
          >
            {button.label}
          </Button>
        );
      })}
    </div>
  );
};

export default SubMenu;
